<template>
  <div>
    <!-- Direct Navigation -->
    <direct-navigation-card entityType="entitlements" basePath="/admin/licensing/entitlements" />

    <!-- Filters -->
    <the-search-filter i18nPrefix="entitlements" :loading="state.loading" :searchFilter="state.searchFilter"
      @clear="clearSearchFilter" @filterInput="param => updateInput(param)" @search="() => buildFilterParams()"
      @urlFiltersInitialized="initializeFiltersFromUrl" />

    <entitlements-table :params="state.fetchParams" :key="state.entitlementsTableKey" />
  </div>
</template>

<script setup>
import { reactive, onMounted, ref, watchEffect } from "vue";
import TheSearchFilter from "@/components/TheSearchFilter.vue";
import DirectNavigationCard from "@/components/utils/DirectNavigationCard.vue";
import EntitlementsTable from "@/components/entitlements/EntitlementsTable.vue";
import { callFetchProducts } from "@/api/licensing";

const options = ref([]);

const state = reactive({
  entitlementsTableKey: 1,
  fetchParams: {
    count: 10,
    page: 1
  },
  searchFilter: {
    productId: {
      value: undefined,
      acceptedValues: []
    },
    entitlementId: { value: undefined, acceptedValues: "string" },
    licenseKey: { value: undefined, acceptedValues: "string" },
    orderId: { value: undefined, acceptedValues: "string" },
    subscriptionId: { value: undefined, acceptedValues: "string" },
    ownerId: { value: undefined, acceptedValues: "string" },
    userId: { value: undefined, acceptedValues: "string" },
    licenseId: { value: undefined, acceptedValues: "string" }
  },
  loading: false
});

watchEffect(() => {
  state.searchFilter.productId.acceptedValues = options.value.map(option => ({
    text: option.name,
    value: option.id
  }));
});

async function logProductDetails() {
  try {
    const productResponse = await callFetchProducts();

    options.value = productResponse.data.items;
  } catch (error) {
    console.error("Failed to fetch products:", error);
  }
}

/**
 * Clear search filter values
 */
async function clearSearchFilter(clearedFilters) {
  console.log("Clearing Search Changes");
  if (clearedFilters) {
    state.searchFilter = clearedFilters;
  } else {
    Object.keys(state.searchFilter).forEach(key => {
      state.searchFilter[key].value = undefined;
    });
  }
  await logProductDetails();
  buildFilterParams();
}

/**
 * Update a searchFilter property's value
 * @param {Object} param
 * @param {string} param.inputKey
 * @param {any} param.value - depends on which field is updated
 */
function updateInput(param) {
  const paramKey = param.inputKey;
  const paramValue = param.value;
  state.searchFilter[paramKey].value = paramValue;
}

/**
 * Initialize filters from URL query parameters.
 * @param {Object} urlFilters
 */
function initializeFiltersFromUrl(urlFilters) {
  state.searchFilter = urlFilters;
  buildFilterParams();
}

/**
 * Create the parameters object for the request.
 * @param {number} page - positive integer
 */
async function buildFilterParams() {
  state.loading = true;

  Object.keys(state.searchFilter).forEach(key => {
    if (key === "entitlementId") {
      state.fetchParams["entitlementsIds"] = state.searchFilter[key].value;
    } else if (key === "productId") {
      //console.log(state.searchFilter.productId.value?.value)
      state.fetchParams[key] = state.searchFilter.productId.value?.value;
    } else {
      state.fetchParams[key] = state.searchFilter[key].value;
    }
  });

  updateTableKey();
  state.loading = false;
}

const updateTableKey = () => {
  state.entitlementsTableKey = 3 - state.entitlementsTableKey;
};

onMounted(async () => {
  await logProductDetails();
});
</script>
